import React from 'react';

// eslint-disable-next-line max-len
const INFLUXCROWD_LOGO = '/themes/theme/influxcrowd/logo.svg';
const INFLUXCROWD_DARK_LOGO = '/themes/theme/influxcrowd/logo.svg';

const InfluxcrowdTheme = {
  headerLogo: {
    src: INFLUXCROWD_LOGO,
    alt: 'Influxcrowd Logo',
    size: 25,
  },
  darkLogo: {
    src: INFLUXCROWD_DARK_LOGO,
    alt: 'Influxcrowd Logo',
    size: 25,
  },
  linkStyle: {
    color: '#ED0444',
    fontWeight: 800,
    fontSize: '120%',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '4px solid #ED0444',
    height: 80,
  },
  title: 'Influxcrowd',
  isLightOnDark: false,
  organisationId: '7fb89fec-c49d-43db-ae7e-02b149037d47',
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="25"
        src={INFLUXCROWD_DARK_LOGO} alt="Influxcrowd Logo"
      />
      <br /><br />
      {/* <h3>Influxcrowd</h3> */}
    </div>
  ),
  shareSite: 'https://share.influxcrowd.com',
};

export default InfluxcrowdTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/influxcrowd.js
 **/